import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, ZapIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
const solutionPoints = ['Automatische Lead-Erfassung aus allen Kanälen', 'Intelligente Follow-up-Sequenzen, die nie vergessen', 'Echtzeit-Pipeline mit präzisen Umsatzprognosen', 'Nahtlose Integration mit Ihren bestehenden Tools', 'Vollständige Aktivitätshistorie pro Kontakt', 'Automatisierte Reporting-Dashboards'];
const whyUs = [{
  icon: TargetIcon,
  title: 'Close CRM Spezialisten',
  description: 'Wir arbeiten ausschließlich mit Close CRM. Keine Ablenkung durch andere Systeme – 100% Fokus auf Ihre Lösung.'
}, {
  icon: ZapIcon,
  title: 'Implementierung in 2-4 Wochen',
  description: 'Während andere Agenturen Monate brauchen, sind Sie bei uns in wenigen Wochen live – mit vollem Support.'
}, {
  icon: TrendingUpIcon,
  title: '110+ erfolgreiche Projekte',
  description: 'Wir haben über 110 Unternehmer dabei unterstützt, ihren Vertrieb mit Close CRM zu transformieren – mit messbaren Ergebnissen.'
}];
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 lg:py-32 bg-[#0c0c0c]" ref={ref} data-id="element-296" data-mp="3kanb7jn7l1rv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297" data-mp="3p9husnt02ud1">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-298" data-mp="3p8yjvr1rp68i">
          {/* Left side - Solution intro */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6
        }} data-id="element-299" data-mp="3u6glsxhdal70">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-300" data-mp="gug9vjs9ngm9">
              Die Lösung
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-301" data-mp="27y8egeoi8ptp">
              Close CRM – Das Vertriebssystem für{' '}
              <span className="text-[#0ea5e9]" data-id="element-302" data-mp="2mnxjikzpxdz9">Gewinner</span>
            </h2>
            <p className="mt-6 text-lg text-gray-400 leading-relaxed" data-id="element-303" data-mp="2hv4edw0c83mn">
              Close CRM wurde von Vertrieblern für Vertriebler entwickelt. Es
              ist das einzige CRM, das Ihr Team tatsächlich nutzen wird – weil
              es den Verkauf einfacher macht, nicht komplizierter.
            </p>

            <div className="mt-8 space-y-4" data-id="element-304" data-mp="35kyqgbcu1o5u">
              {solutionPoints.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.2 + index * 0.1
            }} className="flex items-start gap-3" data-id="element-305" data-mp="30n6xrf4d5y0l" data-mpi={index}>
                  <div className="w-6 h-6 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-306" data-mp="3d36mtukriqaj">
                    <CheckIcon className="w-4 h-4 text-emerald-400" data-id="element-307" data-mp="344bfgf5zfa5n" />
                  </div>
                  <span className="text-gray-300" data-id="element-308" data-mp="341yqvj5py1jm">{point}</span>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Right side - Why us */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-309" data-mp="2u883khlbvx5i">
            <h3 className="text-2xl font-bold text-white mb-8" data-id="element-310" data-mp="2fgyva3n220v4">
              Warum Close CRM Agentur.de?
            </h3>
            {whyUs.map((item, index) => <div key={index} className="p-6 rounded-2xl bg-[#1a1a1a] border border-white/5" data-id="element-311" data-mp="2ak8h5lut9fcc" data-mpi={index}>
                <div className="flex items-start gap-4" data-id="element-312" data-mp="20rsxmk3v8ipc">
                  <div className="w-12 h-12 rounded-xl bg-[#0ea5e9]/10 flex items-center justify-center flex-shrink-0" data-id="element-313" data-mp="20q83uwpdl3sj">
                    <item.icon className="w-6 h-6 text-[#0ea5e9]" data-id="element-314" data-mp="1rrmrjjahyl07" />
                  </div>
                  <div data-id="element-315" data-mp="1rpthdu0oding">
                    <h4 className="text-lg font-semibold text-white mb-2" data-id="element-316" data-mp="1mt32ha0lwt3m">
                      {item.title}
                    </h4>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-317" data-mp="1huruz5xsauok">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </motion.div>
        </div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-318" data-mp="1hng1odi2bb23">
          <a href="/Kostenloses-Strategiegespraech" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#0ea5e9] text-white font-semibold rounded-lg hover:bg-[#0284c7] transition-all duration-200 shadow-lg shadow-[#0ea5e9]/25" data-id="element-319" data-mp="ywyc2hsj0vky">
            Jetzt kostenlose CRM-Analyse anfordern
          </a>
          <p className="mt-4 text-sm text-gray-500" data-id="element-320" data-mp="b5suny6xtv8j">
            Keine Verpflichtung. Wir analysieren Ihre aktuelle Situation und
            zeigen Potenziale auf.
          </p>
        </motion.div>
      </div>
    </section>;
}